export default "__VITE_ASSET__BAMx9oTw__$_?url__"